
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.35235 8.70657C8.6745 9.01174 9.05705 9.16432 9.5 9.16432C9.94295 9.16432 10.3154 9.01174 10.6174 8.70657C10.9396 8.38106 11.1007 7.99452 11.1007 7.54695C11.1007 7.09937 10.9396 6.723 10.6174 6.41784C10.3154 6.09233 9.94295 5.92958 9.5 5.92958C9.05705 5.92958 8.6745 6.09233 8.35235 6.41784C8.05034 6.723 7.89933 7.09937 7.89933 7.54695C7.89933 7.99452 8.05034 8.38106 8.35235 8.70657ZM6.29866 4.34272C7.18456 3.44757 8.25168 3 9.5 3C10.7483 3 11.8054 3.44757 12.6711 4.34272C13.557 5.21753 14 6.2856 14 7.54695C14 8.17762 13.8389 8.89984 13.5168 9.71361C13.2148 10.5274 12.8423 11.2903 12.3993 12.0023C11.9564 12.7144 11.5134 13.3858 11.0705 14.0164C10.6477 14.6268 10.2852 15.115 9.98322 15.4812L9.5 16C9.37919 15.8576 9.21812 15.6745 9.01678 15.4507C8.81544 15.2066 8.45302 14.7387 7.92953 14.0469C7.40604 13.3349 6.94295 12.6534 6.54027 12.0023C6.15772 11.331 5.80537 10.5782 5.48322 9.74413C5.16107 8.91002 5 8.17762 5 7.54695C5 6.2856 5.43289 5.21753 6.29866 4.34272Z","stroke":"#357D67","stroke-width":"1.5"}})])
          )
        }
      }
    